// src/dataProvider.js
import {
  getFirestore,
  collection,
  getDocs,
  addDoc,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCqfprIuIUWv3AEMTnH2DLsktfvVvhVH2Y",
  authDomain: "pondlifeapp.firebaseapp.com",
  projectId: "pondlifeapp",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const dataProvider = {
  // ✅ List all docs
  getList: async (resource) => {
    const snap = await getDocs(collection(db, resource));
    const data = snap.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));
    return { data, total: data.length };
  },

  // ✅ Get one
  getOne: async (resource, params) => {
    const ref = doc(db, resource, params.id);
    const snap = await getDoc(ref);
    if (!snap.exists()) throw new Error("Document not found");
    return { data: { id: snap.id, ...snap.data() } };
  },

  // ✅ NEW: Get multiple by IDs (needed for dropdowns)
  getMany: async (resource, params) => {
    const results = await Promise.all(
      params.ids.map(async (id) => {
        const ref = doc(db, resource, id);
        const snap = await getDoc(ref);
        return { id: snap.id, ...snap.data() };
      })
    );
    return { data: results };
  },

  // ✅ NEW: Get related docs by foreign key
  getManyReference: async (resource, params) => {
    const q = query(
      collection(db, resource),
      where(params.target, "==", params.id)
    );
    const snap = await getDocs(q);
    const data = snap.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));
    return { data, total: data.length };
  },

  // ✅ Create
  create: async (resource, params) => {
    const docRef = await addDoc(collection(db, resource), params.data);
    return { data: { id: docRef.id, ...params.data } };
  },

  // ✅ Update
  update: async (resource, params) => {
    const ref = doc(db, resource, params.id);
    await updateDoc(ref, params.data);
    return { data: { ...params.data, id: params.id } };
  },

  // ✅ Delete
  delete: async (resource, params) => {
    await deleteDoc(doc(db, resource, params.id));
    return { data: params.previousData };
  },
};

export default dataProvider;
